/**
 * The single chart palette and axis styling for the whole product.
 *
 * Recharts needs literal color values, so these mirror the CSS variables in
 * index.css. Mobile (`components/ChartCard`) and Admin (`components/admin/AdminChart`)
 * both read from here — no screen defines its own chart colors.
 */
export const chartColors = {
  deep: '#102A2A',
  soft: '#2E4D45',
  gold: '#C89432',
  sage: '#7C9A8C',
  goldDeep: '#A5761F',
}

/** Series order. Gold is an accent in third position, never the only series color. */
export const chartPalette = [
  chartColors.deep,
  chartColors.soft,
  chartColors.gold,
  chartColors.sage,
  chartColors.goldDeep,
]

export const chartAxis = {
  tick: { fill: '#5b6f66', fontSize: 11 },
  stroke: '#d8d0bc',
  grid: '#e3dcc9',
}

export const chartTooltip = {
  contentStyle: {
    borderRadius: 12,
    border: '1px solid #d8d0bc',
    background: '#f5f1e6',
    fontSize: 12,
    color: chartColors.deep,
  },
  labelStyle: { color: '#5b6f66', fontSize: 11 },
}
